import { Text } from '../../../../shared-components';
import { Box } from '../../../../shared-components/Box';
import { getDisplayValue } from '../../../brite-viewer/components/benefits/field-utils';

export const SimpleFieldValue = ({ field }) => {
  const { Type, value } = field;

  return (
    <Box flex="right">
      {Type === 'dollar' ||
      Type === 'percent' ||
      Type === 'percentOfEmployeeElectedAmount' ||
      Type === 'text-input' ||
      Type === 'number' ||
      Type === 'text-area' ? (
        <Text label bold>
          {getDisplayValue(value, field)}
        </Text>
      ) : Type === 'toggle' ? (
        <Text label bold>
          {value ? 'Yes' : 'No'}
        </Text>
      ) : Type === 'multipleOfSalary' ? (
        <Text label bold>
          {getDisplayValue(value, field)}X Salary
        </Text>
      ) : Type === 'visionFrequency' ? (
        <Text label bold>
          {value.inputValue}
        </Text>
      ) : Type === 'advancedInputField' ? (
        <AdvancedInputField field={field} value={value} />
      ) : Type === 'surestInputField' ? (
        <SurestInputField field={field} value={value} />
      ) : field.Type === 'prescriptionDrugDeductible' ? (
        <Text label bold>
          {value?.Value === -1
            ? 'Medical Deductible Applies'
            : value?.Value === -2
            ? 'None'
            : value?.Value >= 0
            ? getDisplayValue(value?.Value || '', field, 'dollar')
            : null}
        </Text>
      ) : null}
    </Box>
  );
};

export const Pre = ({ field }) => {
  if (!field?.Pre) {
    return null;
  }
  return (
    <Text
      body
      caption
      css={`
        text-align: right;
      `}
    >
      {field?.Pre}
    </Text>
  );
};

export const Post = ({ field }) => {
  if (!field?.Post) {
    return null;
  }
  return (
    <Text
      body
      caption
      css={`
        text-align: right;
      `}
    >
      {field?.Post}
    </Text>
  );
};

const AdvancedInputField = ({ field, value }) => {
  const fieldTypeOverride = value.PercentOrDollar === '$' ? 'dollar' : 'percent';
  const copay = value?.PercentOrDollar === '$' ? (value?.MaxValue !== null ? 'Copay Range' : 'Copay') : 'Coinsurance';
  const copayPlusPercentOrAD = 'After Deductible';
  const hundredCovered = '100% Covered';
  const notCovered = 'Not Covered';

  const ADOrCopay =
    value?.ADOrCopay === 'COPAY'
      ? copay
      : value?.ADOrCopay === 'COPAY + %' || value?.ADOrCopay === 'AD'
      ? copayPlusPercentOrAD
      : value?.ADOrCopay === '100% Covered'
      ? hundredCovered
      : value.ADOrCopay === 'Not Covered'
      ? notCovered
      : '';

  return (
    <Box
      flex="right"
      css={`
        gap: 4px;
      `}
    >
      {value.ADOrCopay === 'COPAY + %' ? (
        <Text label bold>
          {getDisplayValue(value?.SpecialCopay || '', field, 'dollar')} Copay plus
        </Text>
      ) : null}
      {value.ADOrCopay != 'Not Covered' && value.ADOrCopay != '100% Covered' ? (
        <Text label bold>
          {getDisplayValue(value.Value, field, fieldTypeOverride)}
        </Text>
      ) : null}
      {value.ADOrCopay === 'COPAY' && value?.MaxValue !== null ? (
        <Text label bold>
          - {getDisplayValue(value?.MaxValue, field, fieldTypeOverride)}
        </Text>
      ) : null}
      <Text label bold>
        {ADOrCopay}
      </Text>
    </Box>
  );
};

const SurestInputField = ({ field, value }) => {
  return (
    <Box
      flex="right"
      css={`
        gap: 4px;
      `}
    >
      {value?.lower > 0 ? (
        <Text label bold>
          {getDisplayValue(value?.lower || '', field)} -
        </Text>
      ) : null}
      <Text label bold>
        {getDisplayValue(value?.upper || '', field)}
      </Text>
      <Text label bold>
        {value.upper > 0 ? 'Copay Range' : 'Copay'}
      </Text>
    </Box>
  );
};
